import { CalculatorType } from "../../objects/orders/calculatorType";
import { Location } from "../../objects/management/locationManagement/location"
import { OrderItem } from "../../objects/orders/orderItem";
import { CanadianCurrencyCode } from "../../objects/currencyExchange/canadianCurrencyCode";
import { CalculatorAccordion } from "../../components/calculator/accordions/product-accordion/calculator-accordion.component";
import { ESOrder, Order } from "../../objects/orders/order";
import { Product } from "../../objects/products/product";
import { OrderOptions } from "../../objects/orders/orderOptions";
import { TaxType } from "../../objects/orders/taxType";
import { Duty, DutyType } from "../../objects/calculator/duty";
import { CountryService } from "../../services/CountryService";
import { CanadianTaxService } from "../../services/calculator/canadianTaxService";
import { UsaTaxService } from "../../services/calculator/usaTaxService";
import { BaseTaxService } from "../../services/calculator/baseTaxService";
import { OrderStatus } from "../../objects/orders/orderStatus";
import { ImporterType } from "../../objects/calculator/public/types/type";

/**
 * Created by vlad.p on 9/11/2017.
 */

export class CalculatorHelper {

    public static getCalculatorType(locations: Location[]): CalculatorType {
        if (!locations || locations.length == 0)
            return null;

        let shipmentTo: Location = locations.find(x => x.Type == 2);

        if (shipmentTo.Country.toLowerCase() == 'canada')
            return 0;

        if (shipmentTo.Country.toLowerCase() == 'united states' || shipmentTo.Country.toLowerCase() == 'usa')
            return 1;

        return null;
    }

    public static isSameCurrency(orderItems: OrderItem[]): boolean {
        if (orderItems == null || orderItems.length == 0)
            return false;

        let firstCurrency: CanadianCurrencyCode = orderItems[0].CanadianCurrencyCode;

        for (let i = 1; i < orderItems.length; i++) {
            if (String.isNullOrEmpty(orderItems[i].CanadianCurrencyCode.Code))
                return false;

            if (firstCurrency.Code == null || orderItems[i].CanadianCurrencyCode == null)
                continue;

            if (firstCurrency.Code != orderItems[i].CanadianCurrencyCode.Code) {
                return false;
            }
        }

        return true;
    }

    public static getDefaultCurrency(currencyCodes: CanadianCurrencyCode[], order: Order, countryService: CountryService): CanadianCurrencyCode {
        if (!order || !order.Customer || !order.Customer.Location)
            return new CanadianCurrencyCode();

        //According tot BB-1745 default currency must be USD
        return currencyCodes.find(x => x.Name == 'USD');

        // let countryCurrencies: string[] = countryService.getCode(order.Customer.Location.Country);
        //
        // if (!countryCurrencies || countryCurrencies.length == 0)
        //     return currencyCodes.find(x => x.Name == 'CAD');
        //
        // let countryCode: CanadianCurrencyCode = currencyCodes.find(x => countryCurrencies.indexOf(x.Name) != -1);
        //
        // if (countryCode != null)
        //     return countryCode;
        //
        // return currencyCodes.find(x => x.Name == 'CAD');
    }

    public static setDefaultCurrency(currencyCodes: CanadianCurrencyCode[], order: Order, productAccordions: CalculatorAccordion[], countryService: CountryService, changeForAll: boolean = true): void {
        let defaultCurrency = this.getDefaultCurrency(currencyCodes, order, countryService);

        for (let accordion of productAccordions) {
            if (!accordion || !accordion.orderItem)
                continue;

            if (accordion.orderItem.CanadianCurrencyCode == null || accordion.orderItem.CanadianCurrencyCode.Id == null ||
                (!changeForAll && (!accordion.orderItem.Price && !accordion.orderItem.Manufacturer.Name && !accordion.orderItem.Product.HsCode))) {

                accordion.changeCurrency(defaultCurrency);
            }
        }
    }

    public static getProductTariff(product: Product, orderItem: OrderItem, order: Order, hsCodes10 = new Array<string>(), hsCodes25 = new Array<string>(), hsCodes0 = new Array<string>(), usHsCodes25 = new Array<string>()): string {
        const special = CalculatorHelper.checkSpecialCanadianHsCodes(product.HsCode, order, orderItem,  hsCodes10, hsCodes25, usHsCodes25);

        if (special != null)
            return special;

        if (!orderItem.Manufacturer || !orderItem.Manufacturer.Name)
            return product.BaseTariff;

        let item: OrderItem = new OrderItem();

        item.Product = product;
        item.Manufacturer = orderItem.Manufacturer;

        return this.getTariff(item, order, order.Flag && order.Flag.hasFlag(OrderOptions.IsVehicle), hsCodes10, hsCodes25, hsCodes0, usHsCodes25);
    }

    private static checkSpecialCanadianHsCodes(hsCode: string, order: Order, orderItem: OrderItem, hsCodes10 = new Array<string>(), hsCodes25 = new Array<string>(), hsCodes0 = new Array<string>(), usHsCodes25 = new Array<string>()): string | null {
        if ((hsCodes10.length <= 0 && hsCodes25.length <= 0 && hsCodes0.length <= 0 && usHsCodes25.length <= 0) || String.isNullOrEmpty(hsCode))
            return null;

        if (!orderItem.Manufacturer || !orderItem.Manufacturer.Name)
            return null;

        let shipmentTo: Location = order.Locations.find(x => x.Type == 2);
        let manufacturer = orderItem.Manufacturer.Code;

        if (!manufacturer || !shipmentTo)
            return null;

        let countryFrom = manufacturer;
        const countryTo = shipmentTo.Country;

        if (String.isNullOrEmpty(countryFrom) || String.isNullOrEmpty(countryTo))
            return null;

        countryFrom = countryFrom.toLowerCase();

        if (((countryFrom == "us") && (countryTo.toLowerCase() == "canada"))) {
            if (hsCodes0.find(x => hsCode.indexOf(x) != -1))
                return 'Free';
            if (hsCodes10.find(x => hsCode.indexOf(x) != -1))
                return '10%';
            if (hsCodes25.find(x => hsCode.indexOf(x) != -1))
                return '25%';
        }

        return null;
    }

    private static checkSpecialUsHsCodes(hsCode: string, order: Order, orderItem: OrderItem, hsCodes25 = new Array<string>()): number | null {
        if (hsCodes25.length <= 0 || String.isNullOrEmpty(hsCode))
            return null;

        if (!orderItem.Manufacturer || !orderItem.Manufacturer.Name)
            return null;

        let shipmentTo: Location = order.Locations.find(x => x.Type == 2);
        let manufacturer = orderItem.Manufacturer.Code;

        if (!manufacturer || !shipmentTo)
            return null;

        let countryFrom = manufacturer;
        const countryTo = shipmentTo.Country;

        if (String.isNullOrEmpty(countryFrom) || String.isNullOrEmpty(countryTo))
            return null;

        countryFrom = countryFrom.toLowerCase();

        if (((countryFrom == "cn") && (countryTo.toLowerCase() == "united states"))) {
            if (hsCodes25.find(x => hsCode.indexOf(x) != -1))
                return 25;
        }

        return null;
    }

    public static getTariff(orderItem: OrderItem, order: Order, isVehicle: boolean = false, hsCodes10 = new Array<string>(), hsCodes25 = new Array<string>(), hsCodes0 = new Array<string>(), usHsCodes25 = new Array<string>()): string {

        if(orderItem.IsAgentEditCustomDuty){
            let perc = orderItem.AgentEditedCustomDutyPercent;
            return `${perc.toString()}%`;
        }

        if ((orderItem.Product.HsCode == "8703.90.00.00" || orderItem.Product.HsCode == "8703.80.00.00")) {
            if (CalculatorHelper.isLessThanTwentyFive(order, orderItem)
                && !CalculatorHelper.isManufacturerFromCanadaUSAMexico(orderItem)) {
                return `6.1%`;
            } else {
                return '0%';
            }
        }

        if(CalculatorHelper.isMoreOrEqThanTwentyFive(order, orderItem)){
            return 'Free';
        }

        let shipmentTo: Location = order.Locations.find(x => x.Type == 2);
        let shipmentFrom: Location = order.Locations.find(x => x.Type == 1);
        let manufacturer = orderItem.Manufacturer.Code;

        const special = CalculatorHelper.checkSpecialCanadianHsCodes(orderItem.Product.HsCode, order, orderItem, hsCodes10, hsCodes25, hsCodes0, usHsCodes25);

        if (special != null)
            return special;

        const usSpecial = CalculatorHelper.checkSpecialUsHsCodes(orderItem.Product.HsCode, order, orderItem, usHsCodes25);

        if(CalculatorHelper.isPublicCalculatorHsCode(orderItem)
            && (shipmentTo != null && !String.isNullOrEmpty(shipmentTo.Country) && (shipmentTo.Country.toLowerCase() == "us" || shipmentTo.Country.toLowerCase() == "united states"))
            && (shipmentFrom != undefined && !String.isNullOrEmpty(shipmentFrom.Country) && shipmentFrom.Country.toLowerCase() == "china")
            || (order.Customer.Location != undefined && !String.isNullOrEmpty(order.Customer.Location.Country) && order.Customer.Location.Country.toLowerCase() ==  "china")
            || (!String.isNullOrEmpty(manufacturer) && (manufacturer.toLowerCase() == "china" || manufacturer.toLowerCase() == "cn"))
            && !isVehicle)
        {
            let dutyTax = orderItem.Total.Taxes.find(i => i.Type == TaxType.CustomDuty);

            if (dutyTax != null) {
                return  `${dutyTax.Percentage}%`
            }

            return '0%';
        }

        if (shipmentTo != null && !String.isNullOrEmpty(shipmentTo.Country) && orderItem.Manufacturer != null && !String.isNullOrEmpty(orderItem.Manufacturer.Name)
            && orderItem.Manufacturer.Name.toLowerCase() == shipmentTo.Country.toLowerCase() && !isVehicle
            && !(shipmentTo.Country == "Canada" && orderItem.Product.HsCode == "8703.90.00.00")) {
            return 'Free';
        }

        if (shipmentTo != null && !String.isNullOrEmpty(shipmentTo.Country) && !String.isNullOrEmpty(manufacturer)
            && orderItem.Product.HsCode == "9999.99.99.98" &&
            (shipmentTo.Country.toLowerCase() == "us" || shipmentTo.Country.toLowerCase() == "united states") &&
            (manufacturer.toLowerCase() == "china" || manufacturer.toLowerCase() == "cn")) {
            return '0%';
        }

        if (isVehicle) {
            if (!String.isNullOrEmpty(manufacturer) && (orderItem.Product.HsCode == "9999.99.99.98" || orderItem.Product.HsCode == "9999.99.99.99")
                && (this.isMoreOrEqThanTwentyFive(order, orderItem) ||
                manufacturer.toLowerCase() == "mexico" || manufacturer.toLowerCase() == "usa" || manufacturer.toLowerCase() == "united states" || manufacturer.toLowerCase() == "canada")) {
                return '0%';
            }

            let res = orderItem.Total.Taxes.find(x => x.Type == TaxType.CustomDuty);

            if (res) {
                if (res.Percentage == 0 && usSpecial == null)
                    return 'Free';

                let perc = res.Percentage;

                if(usSpecial != null)
                    perc += usSpecial;

                return `${perc.toString()}%`;
            }
        }

        if (orderItem.Manufacturer && orderItem.Manufacturer.Code && orderItem.Product && orderItem.Product.Countries) {
            for (let country of orderItem.Product.Countries) {
                if (country.CountryCode == orderItem.Manufacturer.Code) {
                    let perc = country.Value == "Free" ? 0 : parseFloat(country.Value.split("%")[0]);

                    if(usSpecial != null)
                        perc += usSpecial;
                    return `${perc.toString()}%`;
                }
            }
        }

        let perc = String.isNullOrEmpty(orderItem.Product.BaseTariff) || orderItem.Product.BaseTariff == "Free" ? 0 : parseFloat(orderItem.Product.BaseTariff.split("%")[0]);

        if (shipmentTo != null && !String.isNullOrEmpty(shipmentTo.Country) && !isVehicle && (shipmentTo.Country.toLowerCase() == "canada")
        && CalculatorHelper.isPublicCalculatorHsCode(orderItem))
        {
            return `0%`;
        }

        if(usSpecial != null)
            perc += usSpecial;
        return `${perc.toString()}%`;
    }

    public static isPublicCalculatorHsCode(orderItem: OrderItem ): boolean {
        return (orderItem.Product.HsCode == "9999.99.99.98" || orderItem.Product.HsCode == "9999.99.99.99");
    }

    public static isQuickQuote(order: Order): boolean {
        if (order.Flag == null)
            return false;

        return order.Flag.hasFlag(OrderOptions.IsQuickQuote);
    }

    public static isQuickQuoteES(order: ESOrder): boolean {
        if (order.Flag == null)
            return false;

        return order.Flag.hasFlag(OrderOptions.IsQuickQuote);
    }

    public static isUsService(order: Order): boolean {
        if (order == null || order.Flag == null)
            return false;

        return order.Flag.hasFlag(OrderOptions.IsUsService);
    }

    public static getTariffs(calculatorType: number, tariff: string, orderItem: OrderItem): void {
        let service: BaseTaxService;

        switch (calculatorType) {
            case (0):
                service = new CanadianTaxService();
                break;
            case(1):
                service = new UsaTaxService();
                break;
            default:
                return;
        }

        CalculatorHelper.mergeDutyLists(service.parseTariff(tariff), orderItem.DutyList);
    }

    public static mergeDutyLists(parsedDuties: Duty[], currentDuties: Duty[]): void {
        if (currentDuties == null || currentDuties.length == 0) {
            Object.assign(currentDuties, parsedDuties);
            return;
        }

        if (this.isManualDuties(parsedDuties, currentDuties)) {
            parsedDuties[0].Value = currentDuties[0].Value;
            return;
        }

        for (let parsedDuty of parsedDuties) { // 1 update existing duties

            let itemDuty: Duty = currentDuties
                .find(x => x.DutyType == parsedDuty.DutyType && x.Measure == parsedDuty.Measure);

            if (itemDuty == null) { // 2 add not existing duties
                currentDuties.push(parsedDuty);
                continue;
            }

            itemDuty.Measure = parsedDuty.Measure;
            itemDuty.Value = parsedDuty.Value;
        }

        for (let i = currentDuties.length - 1; i >= 0; i--) { //3 remove not parsed duties
            let parsedDuty: Duty = parsedDuties
                .find(x =>
                    x.DutyType == currentDuties[i].DutyType &&
                    x.Measure == currentDuties[i].Measure);

            if (parsedDuty == null)
                currentDuties.splice(i, 1);
        }
    }

    private static isManualDuties(parsedDuties: Duty[], currentDuties: Duty[]): boolean {
        return parsedDuties.length == 1 && currentDuties.length == 1 && parsedDuties[0].DutyType == DutyType.Manual && currentDuties[0].DutyType == DutyType.Manual;
    }


    public static isVehicle(order: Order): boolean {
        if (!order || !order.Flag)
            return false;

        return order.Flag.hasFlag(OrderOptions.IsVehicle);
    }

    public static isVehicleES(order: ESOrder): boolean {
        if (!order || !order.Flag)
            return false;

        return order.Flag.hasFlag(OrderOptions.IsVehicle);
    }

    public static isCanadianVehicleCalculator(order: Order): boolean {
        if (!this.isVehicle(order))
            return false;

        let shipmentTo: Location = order.Locations.find(x => x.Type == 2);

        if (shipmentTo == null)
            return false;

        if (shipmentTo.Country.toLowerCase() == "canada")
            return true;

        return false;
    }

    public static isUsaShipmentFrom(order: Order): boolean {
        if (!order.Customer || !order.Customer.Location || String.isNullOrEmpty(order.Customer.Location.Country))
            return false;

        return order.Customer.Location.Country.toLowerCase() == 'usa' || order.Customer.Location.Country.toLowerCase() == 'united states';
    }


    public static isManufacturerFromCanadaUSAMexico(orderItem: OrderItem): boolean {
        const manufacturerCode =  orderItem.Manufacturer.Code;
        return manufacturerCode.toLowerCase() === 'mx' || manufacturerCode.toLowerCase() === 'ca' || manufacturerCode.toLowerCase() === 'us';
    }

    public static isUsaShipmentTo(order: Order): boolean {
        return order.Locations.find((x: any) => (x.Country && (x.Country.toLowerCase() == 'usa' || x.Country.toLowerCase() == 'united states')) && x.Type == 2) != null;
    }

    public static replaceOrderPrefix(query: string): string {
        if (String.isNullOrEmpty(query))
            return query;

        let regex = new RegExp(/(^bb-[0-9]*$|^b$|^bb$)/i);

        let match = regex.exec(query);

        if (query.match(regex)) {
            query = match[1].replace(/(bb?-?)/i, '');
        }

        return query;
    }

    public static isUsedEquipment(product: Product): boolean {
        if (!product || String.isNullOrEmpty(product.HsCode))
            return false;

        if (product.HsCode == '8429.52.00.92' || product.HsCode == '8429.51.00.66')
            return true;

        return false;
    }

    /**
     * generate years array
     * @param from - the highest year
     * @param to - the lowest year
     */
    public static generateYearsArray(from: number, to: number): Array<number> {
        let result = new Array<number>();

        for (let i = from; i >= to; i--) {
            result.push(i);
        }

        return result;
    }

    public static calculateGrantTotalForItem(orderItem: OrderItem, order: Order): number {
        let result: number = 0;

        for (let tax of orderItem.Total.Taxes) {
            if(this.isCanadianVehicleCalculator(order)) {
                if (tax.Type == TaxType.AdminFee || tax.Type == TaxType.RIV)
                    continue;
                if (!order.IsCommercial && tax.Type == TaxType.CustomPST)
                    continue;
            }
            result += tax.Value;
        }

        return result;
    }

    public static getButtonValue<T = boolean>(value: T, currentValue?: T): T {
        if (currentValue == value)
            return null;

        return value;
    }

    public static getMeanValue = (x: number, y: number): number => Math.round((y + x) / 2);

    public static getCurrencyName(order: Order): string {
        if (!order || !order.Currency)
            return null;

        return order.Currency.Name;
    }

    public static isMoreOrEqThanTwentyFive(order: Order, orderItem: OrderItem): boolean {
        if (!CalculatorHelper.isVehicle(order))
            return false;

        return new Date().getFullYear() - orderItem.Year >= 25;
    }

    public static isLessThanTwentyFive(order: Order, orderItem: OrderItem): boolean {
        if (!CalculatorHelper.isVehicle(order))
            return false;

        return new Date().getFullYear() - orderItem.Year < 25;
    }

    public static calculateProductsValue(selectedCode: CanadianCurrencyCode, order: Order): number {
        let total: number = 0;

        if (selectedCode == null)
            return total;

        for (let orderItem of order.OrderItems) {
            if (orderItem.CanadianCurrencyCode.Code == selectedCode.Code) {
                total += orderItem.Price;
                continue;
            }

            let price: number = orderItem.Price * orderItem.CanadianCurrencyCode.Value; //convert to canadian

            total += price / selectedCode.Value;
        }

        return total;
    }

    public static getTotalPriceCurrencyCode(order: Order, canadianCurrencyCodes: CanadianCurrencyCode[]): CanadianCurrencyCode {
        if (order.Status >= OrderStatus.Paid) {
            if (CalculatorHelper.isSameCurrency(order.OrderItems))
                return order.OrderItems[0].CanadianCurrencyCode;

            return order.Currency;
        }

        if (CalculatorHelper.isSameCurrency(order.OrderItems))
            return canadianCurrencyCodes.find(x => x.Code == order.OrderItems[0].CanadianCurrencyCode.Code);

        return canadianCurrencyCodes.find(x => x.Code == order.Currency.Code);
    }

    /**
     * if null => not hst pr qst
     * if true => HST
     * if false => QST
     * @param {Order} order
     */
    public static isHQst(order: Order): boolean | null {
        const loc = order.Locations.find(x => x.Type == 2);

        if (loc == null)
            return null;

        if (this.getListOfHstProvincial().find(x => x.indexOf(loc.State) != -1) != null) {
            return true;
        }

        if (this.getListOfQstProvincial().find(x => x.indexOf(loc.State) != -1) != null) {
            return false;
        }

        return null;
    }

    public static getListOfHstProvincial(): Array<string> {
        let arr = new Array<string>();

        arr.push("New Brunswick");
        arr.push("Newfoundland and Labrador");
        arr.push("Nova Scotia");
        arr.push("Ontario");
        arr.push("Prince Edward Island");

        return arr;
    }

    public static getListOfQstProvincial(): Array<string> {
        let arr = new Array<string>();

        arr.push("Quebec");

        return arr;
    }

    public static IsBBFeeEdited(order: Order): boolean {
        if (order.Flag != null && order.Flag.hasFlag(OrderOptions.IsBBFeeEdited))
            return true;

        return false;
    }

    public static checkOrderImporterType(order: Order): ImporterType {
        if (order.Flag || order.Flag === 0) {
            if (order.Flag.hasFlag(OrderOptions.IsVehicle)) {
                return 0;
            } else
                return 1;
        }
    }

    static isCanadaShipmentTo(order: Order) {
        return order.Locations.find((x: any) => (x.Country && x.Country.toLowerCase() == 'canada') && x.Type == 2) != null;
    }
}



// WEBPACK FOOTER //
// ./app/common/helpers/calculatorHelper.ts